import { Button, Row, Col, Space, Dropdown, MenuProps } from "antd";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAuthDispatch } from "../provider/AuthProvider";
import * as Common from "../commons/common";
import React from "react";

import styles from "./LayoutHeader.module.css";
import { Link } from "react-router-dom";
import logoImageLight from "../assets/images/logo_light.svg";
import logoImageDark from "../assets/images/logo_dark.svg";

function LayoutHeader() {
    const navigate = useNavigate();
    const dispatch = useAuthDispatch();

    const handleLogout = () => {
        //localStorage.removeItem("currentUser");

        if (dispatch !== null) dispatch({ type: "LOGOUT" });

        navigate(Common.PAGE_LOGIN);
    };

    const items: MenuProps["items"] = [
        {
            key: "1",
            label: (
                <Space style={{ color: "red" }} onClick={handleLogout}>
                    <span>로그아웃</span>
                    <LogoutOutlined />
                </Space>
            ),
        },
    ];

    return (
        <header className={styles.header}>
            <Row justify={"space-between"}>
                <Col onClick={() => navigate(Common.PAGE_DASHBOARD)} style={{ cursor: "pointer" }}>
                    <Space>
                        <img className={styles.logo} src={logoImageDark} />
                        <span className={styles.title}>통합 관리자</span>
                    </Space>
                </Col>
                <Col>
                    <Space>
                        <Dropdown menu={{ items }} placement="bottomLeft">
                            <Button shape="circle" size="large">
                                <UserOutlined style={{ fontSize: 16 }} />
                            </Button>
                        </Dropdown>
                    </Space>
                </Col>
            </Row>
        </header>
    );
}

export default LayoutHeader;
